<template lang="pug">
  .module__main
    .module-content__container
      .users-control__block
        el-button.user-add__btn(type="primary" size="mini" @click="openUserAdding()") Добавить пользователя
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="users"
            style="width: 100%; font-size: 12px"
          )
            el-table-column(prop="name" label="Логин" width="160" sortable)
            el-table-column(prop="role" label="Роль" width="100" sortable)
              template(slot-scope="scope")
                span {{ roles[scope.row.role] || scope.row.role }}
            el-table-column(label="Лимит закрытия" width="200")
              template(slot-scope="scope")
                .limit__container(v-if="scope.row.role === 'support'")
                  span {{ `${scope.row.support_limit.filled}/${scope.row.support_limit.max}` }}
                  i.el-icon-refresh.limit__btn(@click="startResetSupportLimit(scope.row.name)")
                  i.el-icon-edit.limit__btn(@click="activateLimitChange(scope.row)")
            el-table-column(label="Управление" width="100")
              template(slot-scope="scope")
                .user-controll__container(v-if="scope.row.name !== username")
                  el-button(type="danger" size="mini" @click="startDeleteUser(scope.row.name)") Удалить
    el-dialog(:visible.sync="isUserAdding" :before-close="resetUserAdding" title="Добавление пользователя" width="50%")
      AddUser(v-if="isUserAdding" :roles="roles" @resetUserAdd="resetUserAdding" @updateUsers="loadUsersList")
    el-dialog(:visible.sync="isLimitChanging" :before-close="resetLimitChange" title="Изменение максимального лимита" width="30%")
      .balance-dialog__container
        .title Введите лимит
        el-input(type="number" v-model="limitChange.value" placeholder="Лимит")
        .user-add__buttons
          el-button(type="success" @click="changeUserLimit()") Изменить
          el-button(type="danger" @click="resetLimitChange()") Отменить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  CREATE_USER, DELETE_USER,
  EDIT_SUPPORT_LIMIT,
  EDIT_USER,
  LOAD_USERS_LIST,
  RESET_SUPPORT_LIMIT,
} from '../../store/const/user';
import AddUser from "./AddUser";
import instruments from '../../mixins/instruments';

export default {
  name: 'UsersList',
  components: {
    AddUser,
  },
  mixins: [
    instruments,
  ],
  data() {
    return {
      isUserAdding: false,
      isLimitChanging: false,
      limitChange: {
        name: '',
        value: 0,
      },
    }
  },
  mounted() {
    this.loadUsersList();
  },
  computed: {
    ...mapGetters([
      'loading',
    ]),
    ...mapGetters('user', [
      'users',
      'username',
    ]),
    ...mapGetters('settings', [
      'roles',
    ]),
    isLoading() {
      return this.loading(LOAD_USERS_LIST) === 'loading';
    },
  },
  methods: {
    ...mapActions('user', {
      loadUsersList: LOAD_USERS_LIST,
      addNewUser: CREATE_USER,
      editUser: EDIT_USER,
      editLimit: EDIT_SUPPORT_LIMIT,
      resetLimit: RESET_SUPPORT_LIMIT,
      deleteUser: DELETE_USER,
    }),
    openUserAdding() {
      this.isUserAdding = true;
    },
    resetUserAdding() {
      this.isUserAdding = false;
    },
    activateLimitChange(user) {
      this.limitChange.name = user.name;
      this.limitChange.value = user.support_limit.max;
      this.isLimitChanging = true;
    },
    resetLimitChange() {
      this.limitChange = {
        name: '',
        value: 0,
      };
      this.isLimitChanging = false;
    },
    async changeUserLimit() {
      this.$confirm(
        `Вы уверены, что хотите изменить лимит пользователя?`,
        'Изменение пользователя'
      ).then(async () => {
        const value = parseInt(this.limitChange.value);
        if (!value) {
          this.$message.info(`Введите лимит`);
          return;
        } else if (value < 0) {
          this.$message.info('Значение должно быть положительным');
          return;
        }
        const request = await this.editLimit({
          data: { name: this.limitChange.name, value },
        });
        if (request.success) {
          this.$message.success('Лимит успешно изменен');
          void this.loadUsersList();
          this.resetLimitChange();
        } else {
          this.$message.error(`Ошибка изменения лимита: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Изменение лимита отменено');
      });
    },
    async startResetSupportLimit(name) {
      this.$confirm(
        `Вы уверены, что хотите сбросить лимит пользователя?`,
        'Изменение пользователя'
      ).then(async () => {
        const request = await this.resetLimit({ name });
        if (request.success) {
          this.$message.success('Лимит успешно сброшен');
          void this.loadUsersList();
        } else {
          this.$message.error(`Ошибка сброса лимита: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Сброс лимита отменен');
      });
    },
    async startDeleteUser(name) {
      this.$confirm(
        `Вы уверены, что хотите удалить пользователя ${name}?`,
        'Удаление пользователя'
      ).then(async () => {
        const request = await this.deleteUser({ name });
        if (request.success) {
          this.$message.success('Пользователь успешно удален');
          void this.loadUsersList();
        } else {
          this.$message.error(`Ошибка удаления пользователя: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Удаление пользователя отменено');
      });
    },
  }
};
</script>
<style scoped>
.users-control__block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.user-add__btn {
    width: 160px;
}

.limit__btn {
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
}
</style>
